










import Vue from 'vue'
import style from './style.module.scss'

export default Vue.extend({
    name: 'text-input',
    components: {

    },
    props: {
        value: {
            type: [String, Number],
            default: '',
            required: false
        },
    },
    data() {
        return {
            style: style
        }
    }
})
